<template>
  <div
    class="ws-title"
    :class="{'ellipsis-2':isEllipsis2,bold:bold,display:display,h1:h1,h2:h2,h3:h3,h4:h4,h5:h5,h6:h6,remark:remark}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: "WsTitle001",
  props: {
    isEllipsis2: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    display: {
      type: Boolean,
      default: false,
    },
    h1: {
      type: Boolean,
      default: false,
    },
    h2: {
      type: Boolean,
      default: false,
    },
    h3: {
      type: Boolean,
      default: false,
    },
    h4: {
      type: Boolean,
      default: false,
    },
    h5: {
      type: Boolean,
      default: false,
    },
    h6: {
      type: Boolean,
      default: false,
    },
    remark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>